module.exports = __webpack_public_path__ + "static/media/confetti.8507b939.svg";